import ComponentInterface from "./ComponentInterface";

export default class Component implements ComponentInterface
{
    config: Object;

    constructor(config: Object) {
        this.config = config;
    }

    getConfig(): Object {
        return this.config;
    }

    getComponentConfig(): Object {
        return this.config['config'];
    }

    getType(): String {
        return this.config['type'];
    }
}


// WEBPACK FOOTER //
// ./src/services/components/Component.ts